<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-header>
			<app-breadcrumb [paths]="paths"></app-breadcrumb>
		</app-page-header>

		<app-page-actions>
			<app-button class="carousel-view-btn" *ngIf="vo.list.elements.size !== 0" (click)="navigateToCarouselView()"
									id="{{ cmpId + '-carousel-view' }}"
									[leftIcon]="DcIcons.ViewCarousel"
									i18n="@@dashboard.carouselView">
				navigate-carousel-view
			</app-button>

			<mat-form-field
				class="app-dashboard-list__include-public-select"
				[appearance]="'legacy'">
				<mat-select
					[value]="vo.includePublic"
					(selectionChange)="toggleIncludePublic($event)"
					disableOptionCentering>
					<mat-option [value]="true">
						<span i18n="@@dashboard.list.allProjects">all projects</span>
					</mat-option>
					<mat-option [value]="false">
						<span i18n="@@dashboard.list.thisProject">this project</span>
					</mat-option>
				</mat-select>
			</mat-form-field>
			<button
				matTooltip="new"
				id="{{ cmpId }}-new-btn"
				i18n-matTooltip="@@general.action.new"
				mat-icon-button
				color="primary"
				(click)="createNewDashboard()">
				<mat-icon [svgIcon]="ActionIcons.AddExpositionAccess"></mat-icon>
			</button>
		</app-page-actions>

		<app-page-content>
			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[actionsAvailable]="toggleActions"
				[itemsCount]="vo.list.elements.size"
				[actions]="panelActions"
				(refresh)="refresh()"
				(search)="search($event)">
				<span panel-info>
					<div *ngIf="selectionCount">
						<span>{{ selectionCount }} &#32;</span>
						<span i18n="@@dashboard.columns.config.selectedElements">
							Elements selectionnée
						</span>
					</div>
				</span>
				<div panel-title class="app-panel__title">
					<mat-icon [svgIcon]="HdIcons.Dashboard"></mat-icon>
					<span i18n="@@dashboard.list.title">
                        Dashboards
                    </span>
				</div>
				<dx-data-grid
					keyExpr="id"
					[elementAttr]="{ id: 'dashboard-list', class: 'app-dashboard-list' }"
					[dataSource]="vo.list.elements | toArray"
					[hoverStateEnabled]="true"
					[showColumnHeaders]="true"
					[allowColumnResizing]="true"
					[columnAutoWidth]="false"
					[showRowLines]="false"
					[showColumnLines]="false"
					[rowAlternationEnabled]="false"
					[showBorders]="false"
					[width]="'100%'"
					[noDataText]="''"
					(onRowClick)="navigateToDashboard($event.data)"
					(onCellHoverChanged)="onCellHover($event)"
					(onSelectionChanged)="onSelectionChange($event)"
					(onContentReady)="onGridContentReady()">
					<dxo-selection
						mode="multiple"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="vo.isFirstLoad"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container *ngFor="let col of vo.list.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'code'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'label'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[minWidth]="100"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="labelTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'description'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'projectLabel'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'tags'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[filterOperations]="[DxOperations.Contains, DxOperations.In]"
							[calculateFilterExpression]="calculateTagsHeaderFilterExpression"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="tagsTemplate">
							<dxo-header-filter [dataSource]="tagsHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'updateDate'"
							[dataField]="col.field"
							[dataType]="col.type"
							[format]="col.format"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="updateDateTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'creationDate'"
							[dataField]="col.field"
							[dataType]="col.type"
							[format]="col.format"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="creationDateTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'updatedByAvatar'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[dataType]="col.type"
							[format]="col.format"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="[DxOperations.Contains, DxOperations.NotContains, DxOperations.StartsWith, DxOperations.In]"
							[calculateFilterExpression]="calculateActionByHeaderFilterExpression"
							cellTemplate="updatedByAvatarTemplate">
							<dxo-header-filter [dataSource]="modifiedByHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'createdByAvatar'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="[DxOperations.Contains, DxOperations.NotContains, DxOperations.StartsWith, DxOperations.In]"
							[calculateFilterExpression]="calculateActionByHeaderFilterExpression"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="createdByAvatarTemplate">
							<dxo-header-filter [dataSource]="actionByHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'isActive'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="statusTemplate">
							<dxo-header-filter [dataSource]="actifHeaderFilter"></dxo-header-filter>
						</dxi-column>
					</ng-container>

					<dxi-column
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="vo.list.availableColumns.size + 1"
						[showInColumnChooser]="false"
						[width]="'10rem'"
						cellTemplate="actionsTemplate"></dxi-column>

					<div *dxTemplate="let cell of 'statusTemplate'">
						<app-badge class="status" *ngIf="!cell.data['isActive']">
							<span i18n="@@general.inactive">inactive</span>
						</app-badge>
					</div>

					<div class="label-template" *dxTemplate="let cell of 'labelTemplate'">
						<img [src]="cell.data['pictogramUrl']" [alt]="cell.data['pictogramUrl']"/>
						<span
							class="label-template__label"
							[class.label-template--has-public-project]="cell.data['isProjectPublic'] && !cell.data['isInSameProject']"
							>
							{{ cell.data['label'] }}

							<app-overlay-badge *ngIf="cell.data['isProjectPublic'] && !cell.data['isInSameProject']"
																 id="{{cell.data['id']}}-public-project-label-overlay"
																 [active]="true"
																 [icon]="ComponentIcons.ProjectDetails"
																 [isOpen]="vo.openedOverlays.detailsDashboardId === cell.data['id']"
																 (click)="openPublicProjectDetailsPopover($event, cell.data['id'])">
							<app-popover
								id="public-project-details-popover"
								overlayContent
								label="project"
								i18n-label="@@entity.project.public"
								[icon]="{ iconName: ComponentIcons.ProjectDetails }"
								(adbPopoverClose)="closeOverlay()">
									<app-public-project-view [project]="vo.publicProjectDetails"></app-public-project-view>
							</app-popover>
						</app-overlay-badge>
						</span>
					</div>

					<div *dxTemplate="let cell of 'tagsTemplate'">
						<app-tag-configurator
							*ngIf="cell.data['tags'].length !== 0"
							displayMode="tags"
							configMode="View"
							[configuredTags]="cell.data['tags']"></app-tag-configurator>
					</div>

					<div *dxTemplate="let cell of 'updateDateTemplate'">
						<span>
							{{ cell.data['updateDate'] | date: 'yyyy-MM-dd HH:mm' }}
						</span>
					</div>
					<div *dxTemplate="let cell of 'creationDateTemplate'">
						<span>
							{{ cell.data['creationDate'] | date: 'yyyy-MM-dd HH:mm' }}
						</span>
					</div>

					<div
						*dxTemplate="let cell of 'updatedByAvatarTemplate'"
						class="avatar-template">
						<app-avatar
							*ngIf="cell.data['updatedByAvatar']"
							[avatar]="cell.data['updatedByAvatar']"
							[withTooltip]="true"></app-avatar>
					</div>
					<div
						*dxTemplate="let cell of 'createdByAvatarTemplate'"
						class="avatar-template">
						<app-avatar
							*ngIf="cell.data['createdByAvatar']"
							[avatar]="cell.data['createdByAvatar']"
							[withTooltip]="true"></app-avatar>
					</div>

					<div
						class="actions-column-template"
						*dxTemplate="let cell of 'actionsTemplate'">
						<ng-container *ngIf="cell.data['isInSameProject']">
							<div [hidden]="cell.rowIndex !== currentlyHovered">
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-view-btn"
									mat-icon-button
									class="actions-column-template__btn"
									matTooltip="view-dash"
									i18n-matTooltip="@@dashboard.list.action.view"
									(click)="navigateToDashboard(cell.data, true)">
									<mat-icon [svgIcon]="DcIcons.View"></mat-icon>
								</button>
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-delete-btn"
									mat-icon-button
									class="actions-column-template__btn"
									matTooltip="delete-dash"
									i18n-matTooltip="@@dashboard.list.action.delete"
									(click)="deleteDashboard($event, cell.data)">
									<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
								</button>
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-actions-menu-btn"
									mat-icon-button
									class="actions-column-template__btn"
									(click)="rowMenuOpen($event, cell.rowIndex)"
									[matMenuTriggerFor]="
									cell.data['isActive'] ? activeActions : disabledActions
								"
									[matMenuTriggerData]="{ $implicit: cell.data }">
									<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
								</button>
							</div>
						</ng-container>
						<mat-menu #activeActions="matMenu">
							<ng-template matMenuContent let-data>
								<button
									*ngFor="let a of activeRowActions"
									id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
									(click)="a.action(data)"
									mat-menu-item>
									<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
									<span>{{ a.description }}</span>
								</button>
							</ng-template>
						</mat-menu>
						<mat-menu #disabledActions="matMenu">
							<ng-template matMenuContent let-data>
								<button
									*ngFor="let a of disabledRowActions"
									id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
									(click)="a.action(data)"
									mat-menu-item>
									<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
									<span>{{ a.description }}</span>
								</button>
							</ng-template>
						</mat-menu>
					</div>

					<dxo-group-panel [visible]="true"></dxo-group-panel>

					<!-- Filterable columns	-->
					<dxo-filter-row
						[visible]="vo.list.elements.size !== 0"></dxo-filter-row>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Pagination -->
					<dxo-paging [pageSize]="pageSize"></dxo-paging>
					<dxo-pager
						[visible]="true"
						[showPageSizeSelector]="true"
						[allowedPageSizes]="allowPageSizes"></dxo-pager>

					<dxo-column-chooser
						[allowSearch]="true"
						[enabled]="false"
						[mode]="'select'">
						<dxo-selection
							[allowSelectAll]="true"
							[recursive]="false"></dxo-selection>
					</dxo-column-chooser>

					<dxo-filter-panel [visible]="true"></dxo-filter-panel>

					<!-- State persistence	-->
					<dxo-state-storing
						type="custom"
						[enabled]="true"
						[savingTimeout]="160"
						[customLoad]="loadState"
						[customSave]="saveState"></dxo-state-storing>
				</dx-data-grid>
				<ng-container
					*ngIf="!vo.isLoading && vo.list.elements.size === 0"
					[ngTemplateOutlet]="noData"></ng-container>
			</app-panel>
		</app-page-content>
	</app-page>
</ng-container>

<ng-template #noData>
	<div class="no-data-template">
		<mat-icon
			[svgIcon]="HdIcons.Dashboard"></mat-icon>
		<app-button
			class="small"
			id="{{ cmpId }}-add-new"
			[leftIcon]="DcIcons.AddCircle"
			i18n="@@dashboard.list.action.new"
			(click)="createNewDashboard()">
			new-dashboard
		</app-button>
	</div>
</ng-template>
